import { render } from "./ForgotPasswordView.vue?vue&type=template&id=f1a68740"
import script from "./ForgotPasswordView.vue?vue&type=script&lang=js"
export * from "./ForgotPasswordView.vue?vue&type=script&lang=js"
script.render = render
/* hot reload */
if (module.hot) {
  script.__hmrId = "f1a68740"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('f1a68740', script)) {
    api.reload('f1a68740', script)
  }
  
  module.hot.accept("./ForgotPasswordView.vue?vue&type=template&id=f1a68740", () => {
    api.rerender('f1a68740', render)
  })

}

script.__file = "src/views/auth/ForgotPasswordView.vue"

export default script